export default {
    home (component) {
        if (component.$route.name !== 'home') {
            component.$router.push ({ name: "home"})
        }
    },

    push (component, routname, params) {
        if (component.$route.name === routname) {
            component.$bus.$emit(component.$events.refresh, params);
        } else {
            component.$router.push({ name: routname, params: params }).catch(err => {
                if (err.name === 'NavigationDuplicated') {
                    component.$bus.$emit(component.$events.refresh, params);
                } else {
                    throw err;
                }
            });
        }
    }
}